<div *ngIf="component.data$ | async as data">
  {{ data.content }}
</div>
